export const ANALYTICS_PAGE_TYPE = 'CardHS';
